import React, { useEffect, useState } from 'react';
import { MessageSquareReply, Loader2 } from 'lucide-react';
import { Stars } from './CentreRating';
import { fittingAPI } from '../../services/api';

const fmt = (v) => new Date(v).toLocaleDateString('fr-FR');

// Public list of a centre's reviews with the centre's replies
export const ReviewItem = ({ r, children }) => (
  <li className="py-2 text-sm" data-testid={`centre-review-${r.id}`}>
    <p className="flex flex-wrap items-center gap-2"><Stars value={r.rating} size={12} /> <span className="font-medium text-gray-800">{r.customer_name}</span> <span className="text-xs text-gray-400">{fmt(r.created_at)}</span></p>
    {r.comment && <p className="text-gray-700 mt-0.5">« {r.comment} »</p>}
    {r.reply && (
      <div className="mt-1.5 ml-3 border-l-2 border-orange-300 bg-orange-50/60 rounded-r px-3 py-1.5 text-xs text-gray-700" data-testid={`centre-review-reply-${r.id}`}>
        <p className="font-semibold text-orange-800 inline-flex items-center gap-1"><MessageSquareReply size={11} /> Réponse de {r.reply.author} · {fmt(r.reply.updated_at || r.reply.created_at)}</p>
        <p className="mt-0.5">{r.reply.message}</p>
      </div>
    )}
    {children}
  </li>
);

const CentreReviewsList = ({ centreId }) => {
  const [data, setData] = useState(null);
  useEffect(() => { fittingAPI.centreReviews(centreId).then(setData).catch(() => setData({ items: [] })); }, [centreId]);
  if (!data) return <p className="text-xs text-gray-400 inline-flex items-center gap-1 mt-2"><Loader2 size={11} className="animate-spin" /> Chargement des avis…</p>;
  if (!data.items.length) return <p className="text-xs text-gray-400 mt-2" data-testid={`centre-reviews-empty-${centreId}`}>Pas encore d'avis pour ce centre.</p>;
  return <ul className="divide-y mt-2 rounded-lg border border-gray-200 bg-white px-3" data-testid={`centre-reviews-${centreId}`}>{data.items.map((r) => <ReviewItem key={r.id} r={r} />)}</ul>;
};

export default CentreReviewsList;
